// extracted by mini-css-extract-plugin
export default {"dialogPaper":"styles_dialogPaper__4cyRZ","formBody":"styles_formBody__bO-jn","formBtns":"styles_formBtns__tcl8t"};